import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useTranslation } from 'react-i18next';

const GroupMessageEmailActionButtons = () => {
  const { t } = useTranslation(['common']);
  return (
    <Button
      variant='contained'
      color='secondary'
      startIcon={<AddCircle />}
      component={Link as any}
      to={RoutesEnum.GroupMessageEmailCreate}
      disableElevation
    >
      {t('common:button.create')}
    </Button>
  );
};

export default GroupMessageEmailActionButtons;
